export default "__VITE_ASSET__cRUziQz7__"